import React from "react";
import { Button, Grid, Stack, Typography } from "@mui/material";

import { styled } from "@mui/material/styles";
import propTypes from "prop-types";

const SubscriptionPromoGrid = styled(Grid)(({ theme }) => ({
  // To use Typography theme font sizes based on ems
  // Otherwise the inbox will use the body font size
  // This is generally a bad practice, but considering
  // there's no alternative right now...
  fontSize: "16px !important",
  padding: "2em 1em 0 1em",
  height: "100%",
  background: theme.palette.supportiveDustyBlue.main,
  color: theme.palette.common.white,
  backgroundRepeat: "no-repeat",
  backgroundPosition: "bottom 28px right 12px",
  backgroundSize: "140px",
  backgroundImage:
    "url('https://s3.eu-west-2.amazonaws.com/venue.scanner/img/subscriptionPromo.jpg')",
  [theme.breakpoints.up("md")]: {
    padding: "2em 1.6em 0 1.6em",
    backgroundSize: "auto",
  },
}));

export const SubscriptionPromoContainer = ({ children, ...props }) => (
  <SubscriptionPromoGrid container direction="column" {...props}>
    {children}
  </SubscriptionPromoGrid>
);

SubscriptionPromoContainer.propTypes = {
  children: propTypes.node.isRequired,
};

export const LinkButton = styled(Button)(({ theme }) => ({
  fontSize: "14px",
  background: theme.palette.white.main,
  color: theme.palette.common.black,
  textDecoration: "none",
  justifyContent: "start",
  borderRadius: "12px",
  padding: "12px",
  "&:hover": {
    color: theme.palette.common.white,
  },
}));

export const Title = styled(Typography)({
  margin: "12px 0 32px 0",
});

const SkipButtonStack = styled(Stack)(() => ({
  marginBottom: "32px",
}));

export const SkipButtonContainer = ({ children }) => (
  <SkipButtonStack flex={1} justifyContent="end" alignItems="start">
    {children}
  </SkipButtonStack>
);

SkipButtonContainer.propTypes = {
  children: propTypes.node.isRequired,
};
